// import { dataUpload } from '../../firestoreData/dataUpload';

import _ from "lodash"

export const rts = {
  handleAmmend_startDimmer: 'handleAmmend_startDimmer',
  handleAmmend_useEffect: 'handleAmmend_useEffect',
  handleAmmend_useMemo: 'handleAmmend_useMemo',
  handleKillDimmer: 'handleKillDimmer',
  handleTimeLeft: 'handleTimeLeft',
}

export const startTexts = {
  app: 'Loading',
  authorizing: 'Authorizing',
  settings: 'Loading',
  createEvent: 'Creating Event',
  pending: 'Pending Authorization',
  retrieving: 'Retrieving',
  fetchingRegEvent: 'Fetching Reg Event',
}

export const startTypes = {
  app: 'app',
  authorizing: 'authorizing',
  createEvent: 'createEvent',
  fetchingReg: 'fetchingReg',
  event: 'event',
  finish: 'finish',
  pageItem: 'pageItem',
  retrieving: 'retrieving',
  suspense: 'suspense',
}

const getPathKeys = () => {
  const url = window.location?.hash; // Get the path without the domain
  const clientMatch = url.match(/clients\/([^/]+)/);
  const eventMatch = url.match(/events\/([^/]+)/);
  const clientKey = clientMatch ? clientMatch[1] : null;
  const eventKey = eventMatch ? eventMatch[1] : null;
  return { clientKey, eventKey }
}

export const startReducer = (state, action) => {

  const _pathKeys = getPathKeys()

  const { killInterval } = state
  const { type } = action

  switch (type) {

    case rts.handleAmmend_useMemo:
      const _payloads_memo = { ...state.payloads_memo }
      if (!_payloads_memo[action.effectName]) {
        _payloads_memo[action.effectName] = []
      }
      _payloads_memo[action.effectName].push(new Date())
      return { ...state, payloads_memo: _payloads_memo }

    case rts.handleAmmend_useEffect:
      const _payloads_effect = { ...state.payloads_effect }
      if (!_payloads_effect[action.effectName]) {
        _payloads_effect[action.effectName] = []
      }
      _payloads_effect[action.effectName].push(action.timestamp)
      return { ...state, payloads_effect: _payloads_effect }

    case rts.handleAmmend_startDimmer:

      const { startType, origin, settingsDocName } = action;

      // If no startType: turn dimmer off and exit
      if (!startType) {
        return {
          ...state,
          origin,
          startDimmerOn: false,
          startType: null,
          killDimmer: true,
        };
      }

      // Handle "finish" directly
      if (startType === startTypes.finish) {
        return {
          ...state,
          origin,
          startDimmerOn: false,
          startType,
          startCaption: "Finishing",
          killDimmer: true,
        };
      }

      // Step 1: pick base caption from map
      const baseCaptions = {
        [startTypes.app]: startTexts.app,
        [startTypes.authorizing]: startTexts.authorizing,
        [startTypes.createEvent]: startTexts.createEvent,
        [startTypes.event]: startTexts.settings,
        [startTypes.retrieving]: startTexts.retrieving,
        [startTypes.fetchingReg]: startTexts.fetchingRegEvent,
      };
      let caption = baseCaptions[startType] || "Loading";

      // Step 2: add context suffix
      if (_pathKeys.eventKey) caption += " Event";
      else if (_pathKeys.clientKey) caption += " Client";

      // Step 3: override/append based on startType
      if (startType === startTypes.authorizing) {
        caption = "Authorizing...";
      } else if (
        [startTypes.app, startTypes.event, startTypes.suspense, startTypes.retrieving].includes(startType)
      ) {
        caption += " App...";
      }

      // Final special case (note: this will override the above if suspense)
      if (startType === startTypes.suspense) {
        caption = "Please wait...";
      }

      return {
        ...state,
        origin,
        startDimmerOn: true,
        startType,
        startCaption: caption,
        startDocName: settingsDocName,
      };

    // if (action.startType) {

    //   let caption;

    //   switch (action.startType) {

    //     case startTypes.app:
    //     case startTypes.authorizing:
    //     case startTypes.createEvent:
    //     case startTypes.event:
    //     case startTypes.retrieving:
    //     case startTypes.suspense:
    //     case startTypes.fetchingReg:

    //       switch (action.startType) {
    //         case startTypes.app:
    //           caption = startTexts.app
    //           break;
    //         case startTypes.authorizing:
    //           caption = startTexts.authorizing
    //           break;
    //         case startTypes.event:
    //           caption = startTexts.settings
    //           break;
    //         case startTypes.createEvent:
    //           caption = startTexts.createEvent
    //           break;
    //         case startTypes.retrieving:
    //           caption = startTexts.retrieving
    //           break;
    //         case startTypes.fetchingReg:
    //           caption = startTexts.fetchingRegEvent
    //           break;
    //         default:
    //           caption = 'Loading'
    //         //nothing
    //       }

    //       let _appCaption = caption

    //       if (_pathKeys.eventKey) {
    //         _appCaption += ' Event'
    //       } else if (_pathKeys.clientKey) {
    //         _appCaption += ' Client'
    //       }

    //       switch (action.startType) {
    //         case startTypes.authorizing:
    //           _appCaption = 'Authorizing...'
    //           break;

    //         case startTypes.app:
    //         case startTypes.event:
    //         case startTypes.suspense:
    //         case startTypes.retrieving:
    //           _appCaption += ' App...'
    //           break;

    //         case startTypes.suspense:
    //           _appCaption = 'Please wait...'
    //           break;

    //         default:
    //         // nothing
    //       }

    //       console.log('_appCaption', _appCaption)

    //       return { ...state, origin: action.origin, startDimmerOn: true, startType: action.startType, startCaption: _appCaption, startDocName: action.settingsDocName }

    //     case startTypes.finish:
    //       return { ...state, origin: action.origin, startDimmerOn: false, startType: action.startType, startCaption: 'Finishing', killDimmer: true }

    //     default:
    //       return state
    //     // nothing
    //   }
    // } else {
    //   return { ...state, origin: action.origin, startDimmerOn: false, startType: null, killDimmer: true }
    // }

    case rts.handleTimeLeft:
      return { ...state, timeLeft: killInterval - 1 }

    case rts.handleKillDimmer:
      return { ...state, startDimmerOn: false, startType: null, killDimmer: true }

    default:
      return { ...state }
  }
}

export const startInitialState = (initState) => {
  return { startDimmerOn: true, ...initState, payloads_effect: {} }
};

export const startHandlers = (dispatch) => {
  return {
    handleAmmend_startDimmer: (startType, settingsDocName, origin) => { dispatch({ type: rts.handleAmmend_startDimmer, startType, settingsDocName, origin }) },
    handleAmmend_useEffect: (effectName, data) => { dispatch({ type: rts.handleAmmend_useEffect, effectName, data }) },
    handleAmmend_useMemo: (effectName, data) => { dispatch({ type: rts.handleAmmend_useMemo, effectName, data }) },
    handleKillDimmer: () => { dispatch({ type: rts.handleKillDimmer }) },
    handleTimeLeft: () => { dispatch({ type: rts.handleTimeLeft }) },
  }
}